var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M4 2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 2v16h16V4H4zm9 5c-.518 0-1.065.158-1.548.452L11 9h-1v7h2v-4c0-.576.594-1 1-1h1c.406 0 1 .424 1 1v4h2v-4c0-1.853-1.606-3-3-3h-1zM8 8a1 1 0 1 0 0-2 1 1 0 1 0 0 2zM7 9v7h2V9H7z","fill":"#002035"}));
}

LinkedinInline.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
